const IsNumber = (str?: string) => {
	return str && str.length <= 20 && !isNaN(parseFloat(str))
}

export default IsNumber
